var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8425 3.165C12.6225 0.952498 9.02249 0.952498 6.81749 3.165C5.26499 4.7025 4.79999 6.915 5.39999 8.865L1.87499 12.39C1.62749 12.645 1.45499 13.1475 1.50749 13.5075L1.73249 15.1425C1.81499 15.6825 2.31749 16.1925 2.85749 16.2675L4.49249 16.4925C4.85249 16.545 5.35499 16.38 5.60999 16.1175L6.22499 15.5025C6.37499 15.36 6.37499 15.12 6.22499 14.97L4.76999 13.515C4.55249 13.2975 4.55249 12.9375 4.76999 12.72C4.98749 12.5025 5.34749 12.5025 5.56499 12.72L7.02749 14.1825C7.16999 14.325 7.40999 14.325 7.55249 14.1825L9.14249 12.6C11.085 13.2075 13.2975 12.735 14.8425 11.1975C17.055 8.985 17.055 5.3775 14.8425 3.165ZM10.875 9C9.83999 9 8.99999 8.16 8.99999 7.125C8.99999 6.09 9.83999 5.25 10.875 5.25C11.91 5.25 12.75 6.09 12.75 7.125C12.75 8.16 11.91 9 10.875 9Z",
    fill: "#677481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.e74fe05257388e11fcb3f8f9e0f641cc.svg";
export { ForwardRef as ReactComponent };